import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	{
		label: 'Templates',
		icon: 'acies_template',
		path: 'docs/templates',
		overlay: false,
		children: [],
		parents: ['Docs'],
		shortcut: 'control.alt.d',
		permission: 'docs:TemplateCreate',
		forceTranslateKey: 'docs.sidebar.templates',
	},
	{
		label: 'Mappings',
		icon: 'acies_mapping',
		path: 'docs/mappings',
		overlay: false,
		children: [],
		parents: ['Docs'],
		shortcut: 'control.alt.o',
		permission: 'docs:MappingCreate',
		forceTranslateKey: 'docs.sidebar.mappings',
	},
];
